module.exports = __webpack_public_path__ + "83c07494a78cbf03eba0fa59b988f437.svg";